export default __webpack_public_path__ + "286d0416f727cb9426b7ef93a2d3b0d4.png";